import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Divider } from '../Divider/Divider.js';

var _excluded = ["children"];
var StyledDialogHeader = styled.div.withConfig({
  displayName: "DialogHeader__StyledDialogHeader",
  componentId: "sc-mbwcos-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;justify-content:space-between;align-items:center;padding:", " ", " 0 ", ";"], theme.entities.children.spacings.top, theme.entities.children.spacings.right, theme.entities.children.spacings.left);
});
var StyledDivider = styled(Divider).withConfig({
  displayName: "DialogHeader__StyledDivider",
  componentId: "sc-mbwcos-1"
})(["margin-bottom:0;"]);
var DialogHeader = /*#__PURE__*/forwardRef(function DialogHeader(_ref2, ref) {
  var children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var props = _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref
  });
  return /*#__PURE__*/jsxs("div", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/jsx(StyledDialogHeader, {
      children: children
    }), /*#__PURE__*/jsx(StyledDivider, {
      variant: "small",
      color: "medium"
    })]
  }));
});

export { DialogHeader };
